import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: [-9668262.45031853, 2411193.6258162702],  // playa del carmen en EPGS 3857
    zoom: 16,
  })
});

// Definiendo capas para GeoServer
const layers = [
  {
    name: 'DemoPlayaDelCarmen',
    title: 'Vista Satelital',
    visible: true,
  },
  {
    name: 'manestad',
    title: 'manestad',
    visible: true,
  },
  {
    name: 'zi',
    title: 'zi',
    visible: true,
  },
  {
    name: 'denue',
    title: 'denue',
    visible: true,
  },
  {
    name: 'DemoPlayaDelCarmen Comercios',
    title: 'comercios',
    visible: true,
  },
];

// Añadiendo capas WMS desde GeoServer en base a layer
const geoserverLayers = layers.map((layer) => {
  const wmsLayer = new ImageLayer({
    source: new ImageWMS({
      url: 'https://demoplayadelcarmen.cartografica.xyz/geoserver/demoplayadelcarmen/wms',
      params: { 
        LAYERS: `demoplayadelcarmen:${layer.name}`,
        FORMAT: 'image/png',
        TRANSPARENT: 'TRUE',
      },
      ratio: 1,
      serverType: 'geoserver',
    }),
    visible: layer.visible,
  });
  layer.olLayer = wmsLayer; // Guardar referencia a la capa de OpenLayers
  return wmsLayer;
});

// Añadiendo cada capa al mapa
geoserverLayers.forEach((layer) => map.addLayer(layer));

// Crear controles de capas en la interfaz
const layersContainer = document.getElementById('layers');
layers.forEach((layer) => {
  const label = document.createElement('label');
  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.checked = layer.visible;
  checkbox.addEventListener('change', () => {
    layer.olLayer.setVisible(checkbox.checked);
  });
  label.appendChild(checkbox);
  label.appendChild(document.createTextNode(` ${layer.title}`));
  layersContainer.appendChild(label);
});

// Función para reaccionar al hacer clic
map.on('singleclick', (evt) => {
  const viewResolution = map.getView().getResolution();
  const coordinate = evt.coordinate;

  // Limpiar la tabla previa
  const tableBody = document.querySelector('#info-table tbody');
  tableBody.innerHTML = '';

  // Consultar solo las capas visibles (excluyendo la TIF)
  const visibleVectorLayers = layers.filter(
    (layer) => layer.olLayer.getVisible() && layer.name !== 'DemoPlayaDelCarmen'
  );

  // Si no hay capas visibles terminamos
  if (visibleVectorLayers.length === 0) return;

  // Construir la solicitud para GetFeatureInfo para todas las capas visibles
  visibleVectorLayers.reverse();
  const visibleStringLayers = visibleVectorLayers.map((l) => `demoplayadelcarmen:${l.name}`).join(',')
  const url = visibleVectorLayers[0].olLayer.getSource().getFeatureInfoUrl(
    coordinate,
    viewResolution,
    'EPSG:3857',
    {
      INFO_FORMAT: 'application/json',
      QUERY_LAYERS: visibleVectorLayers.map((l) => `demoplayadelcarmen:${l.name}`).join(','),
      LAYERS: visibleVectorLayers.map((l) => `demoplayadelcarmen:${l.name}`).join(','),
      FEATURE_COUNT: 10, // Máximo de features a devolver
    }
  );

  // Si no hay una URL terminamos
  if (url) {
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Si hay datos en la respuesta seguimos
        if (data.features && data.features.length > 0) {
          const feature = data.features[0];
          const properties = feature.properties;

          // Rellenar la tabla con los atributos
          for (const [key, value] of Object.entries(properties)) {
            const row = document.createElement('tr');
            const keyCell = document.createElement('td');
            const valueCell = document.createElement('td');
            keyCell.textContent = key;
            valueCell.textContent = value || 'N/A';
            row.appendChild(keyCell);
            row.appendChild(valueCell);
            tableBody.appendChild(row);
          }
        }
      })
      .catch((error) => {
        console.error('Error en GetFeatureInfo:', error);
        tableBody.innerHTML = '<tr><td colspan="2">Error al obtener datos</td></tr>';
      });
  }
});

